<template>
  <ul class="history-list">
    <history-item v-for="item in actions" :key="item.id" :action="item" :all="all" />
  </ul>
</template>

<script>
import HistoryItem from './history-item'

export default {
  props: ['actions', 'all'],
  components: {
    HistoryItem
  }
}
</script>

<style lang="less">
.history-list {
  max-height: 50vh;
  overflow: auto;
}
</style>
